import { StubPage } from "~/pages/_shared/StubPage";

export function ReportsPage() {
  return (
    <StubPage
      title="Reporting"
      description="Org-level summaries — total miles sailed, certificates issued, crew activity, and fleet utilisation."
    />
  );
}
